import {AttachmentValidationService} from '../../service/attachment-validation.service';
import {ATTACHMENT_CSD, LAND_CSV} from '../../constants';
import {PlanAttachment} from '../../models/plan-attachment.model';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EvidenceValidationService {
    constructor(private attachmentValidationService: AttachmentValidationService) {}

    hasValidationErrorsOrWarnings(attachment: PlanAttachment) {
        return this.hasValidationErrors(attachment) || this.hasValidationWarnings(attachment);
    }

    hasValidationWarnings(attachment: PlanAttachment) {
        return this.isCsdOrCsv(attachment) && this.attachmentValidationService.getWarnings(attachment.attachmentType).length > 0;
    }

    hasValidationErrors(attachment: PlanAttachment) {
        return this.isCsdOrCsv(attachment) && this.attachmentValidationService.getErrors(attachment.attachmentType).length > 0;
    }

    getValidationWarnings(attachment: PlanAttachment) {
        return this.isCsdOrCsv(attachment) ? this.attachmentValidationService.getWarnings(attachment.attachmentType) : [];
    }

    getValidationErrors(attachment: PlanAttachment) {
        return this.isCsdOrCsv(attachment) ? this.attachmentValidationService.getErrors(attachment.attachmentType) : [];
    }

    private isCsdOrCsv(attachment: PlanAttachment) {
        return attachment?.attachmentType === ATTACHMENT_CSD || attachment?.attachmentType === LAND_CSV;
    }
}
